import classes from "./Dashboard.module.css";
import logo from "../../store/logo.png"
import {
    Button,
    Divider,
    IconButton,
    Tooltip,
    useMediaQuery,
    useTheme
} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import {useState, useEffect, useRef} from "react";
import {path} from "../../routes";
import Organizations from "./ADMIN/Organizations";
import Users from "./ADMIN/Users";
import Displays from "./ADMIN/Displays";
import Servis from "./ADMIN/Servis";

const getAdminStateFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab") || "";
    const org = params.get("org") || "";
    let tabSelected = 0;
    if (tab === "uzivatele") tabSelected = 1;
    else if (tab === "zobrazovace") tabSelected = 2;
    else if (tab === "servis") tabSelected = 3;
    return { tabSelected, org };
};

const updateAdminUrl = (tabSelected, org) => {
    const params = new URLSearchParams(window.location.search);
    if (Number(tabSelected) === 0) params.set("tab", "organizace");
    else if (Number(tabSelected) === 1) params.set("tab", "uzivatele");
    else if (Number(tabSelected) === 3) {
        params.set("tab", "servis");
        if (org) params.set("org", String(org));
        else params.delete("org");
    } else {
        params.set("tab", "zobrazovace");
        if (org) params.set("org", String(org));
        else params.delete("org");
    }
    const query = params.toString();
    const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    window.history.replaceState(null, "", newUrl);
};

const Dashboard_admin = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [tabSelected, setTabSelected] = useState(0);
    const [org, setOrg] = useState(0);
    const isInitialMount = useRef(true);

    useEffect(() => {
        const { tabSelected: t, org: o } = getAdminStateFromUrl();
        setTabSelected(t);
        if (o) setOrg(o);
    }, []);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        updateAdminUrl(tabSelected, org);
    }, [tabSelected, org]);

    const changeTab_handler = (event) => {
        const temp = Number(event.target.value);
        setTabSelected(temp);
        // Při přepnutí na Zobrazovače nebo Servis z menu neresetujeme org jen když jdeme z řádku (loadDisplay/loadServis).
        // Klik na záložku "Servis" v menu = zobrazit všechny; klik na "Servis" v řádku organizace = jen ta organizace.
        if (temp !== 2 && temp !== 3) setOrg(0);
        if (temp === 3) setOrg(0); // záložka Servis z menu = všechny organizace
    };

    const loadDisplay = (orgId) => {
        setOrg(orgId);
        setTabSelected(2);
    };
    const loadServis = (orgId) => {
        setOrg(orgId);
        setTabSelected(3);
    };

    return <div className={classes.flexContainer}>
        <div className={classes.header}>
            <div className={classes.logo}>
                <img src={`${path}/admin/${encodeURI((props.cred.logopath || '').replace(/\\/g, '/'))}`} alt={`${props.cred.organizationName} logo`}/>
            </div>
            <div className={`${classes.menu} ${classes.menuDesktop}`}>
                <Button onClick={changeTab_handler} value={0} color={"primary"} variant={tabSelected === 0 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Organizace</Button>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
                <Button onClick={changeTab_handler} value={1} color={"primary"} variant={tabSelected === 1 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Uživatelé</Button>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
                <Button onClick={changeTab_handler} value={2} color={"primary"} variant={tabSelected === 2 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Zobrazovače</Button>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
                <Button onClick={changeTab_handler} value={3} color={"primary"} variant={tabSelected === 3 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Servis</Button>
            </div>
            <div className={classes.user}>
                <span>{props.cred.username}</span>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
                <Tooltip title="Odhlásit">
                    <IconButton
                        aria-label="Odhlásit"
                        onClick={() => props.logOut()}
                        size={isMobile ? 'small' : 'medium'}
                    >
                        <LogoutIcon />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
        <div className={`${classes.menu} ${classes.menuMobile}`}>
            <Button onClick={changeTab_handler} value={0} color={"primary"} variant={tabSelected === 0 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Organizace</Button>
            <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
            <Button onClick={changeTab_handler} value={1} color={"primary"} variant={tabSelected === 1 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Uživatelé</Button>
            <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
            <Button onClick={changeTab_handler} value={2} color={"primary"} variant={tabSelected === 2 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Zobrazovače</Button>
            <Button onClick={changeTab_handler} value={3} color={"primary"} variant={tabSelected === 3 ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>Servis</Button>
        </div>
        <div className={classes.body}>
            {
                tabSelected === 0 ? <Organizations cred={props.cred} loadDisplay={loadDisplay} loadServis={loadServis}/> :
                    tabSelected === 1 ? <Users cred={props.cred}/> :
                        tabSelected === 2 ? <Displays cred={props.cred} org={org}/> :
                            tabSelected === 3 ? <Servis cred={props.cred} org={org}/> :
                                <Users cred={props.cred}/>
            }
        </div>
        <div className={classes.footer}><p>Copyright &#169; 2026 Computer System Group a.s.</p></div>


    </div>
}

export default Dashboard_admin